<template>
  <div class="payment-records">
    <div class="payment-records-user-info">
      <img :src="require('@assets/ic_user_portrait.png')" alt="" />
      <div class="payment-records-user-info-name">
        <div>{{ userInfo.patientName }}</div>
        <h4>{{ userInfo.cardNo }}</h4>
      </div>
    </div>
    <DateSelectorView
      @dateSelected="confirmPicker"
      class="payment-records-date-picker"
    />
    <div class="payment-records-list">
      <ph-empty v-if="!list.length" bgcolor="white" />
      <div
        v-for="(item, index) in list"
        :key="index"
        class="payment-records-list-item"
      >
        <div>
          <div>
            {{ item.payDate && item.payDate.substr(0, item.payDate.length) }}
          </div>
          <div><span>充值金额：</span> {{ item.payAmount }}</div>
        </div>
        <div>
          <div>{{ item.payPlatForm }}</div>
          <!--<div><span>充值后余额：</span>{{ item.prePay }}</div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateSelectorView from "./DateSelectorView";

export default {
  components: { DateSelectorView },
  data() {
    return {
      show: false,
      ftype: "1",
      userInfo: {},
      list: [],
      startDate: new Date(),
      endDate: new Date()
    };
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    this.startDate = this.$moment()
      .add(-7, "day")
      .toDate();
    this.endDate = this.$moment().toDate();
    this.$http
      .post(this.$api.USER_BASE_INFO, {
        functionType: this.ftype
      })
      .then(res => {
        this.userInfo = res;
      });
    this.loadData();
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    confirmPicker(selStartDate, SelendDate) {
      this.startDate = selStartDate;
      this.endDate = SelendDate;
      this.loadData();
    },
    loadData() {
      this.$http
        .post(this.$api.RECHARGE_PAYMENT_RECORDS, {
          functionType: this.ftype,
          startDate: this.$moment(this.startDate).format("YYYYMMDD"),
          endDate: this.$moment(this.endDate).format("YYYYMMDD")
        })
        .then(res => {
          this.list = res;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.payment-records {
  background: white;

  &-user-info {
    display: flex;
    align-items: center;
    margin: 0.94rem;
    padding: 0.5rem 1rem;
    background-color: @primary-blue;
    border-radius: 5px;

    img {
      width: 2.5rem;
      height: 2.5rem;
      margin-right: 0.81rem;
      border-radius: 50%;
    }

    &-name {
      color: white;
      h4 {
        margin: 0.1rem 0;
        font-weight: 400;
        font-size: 0.88rem;
        opacity: 0.8;
      }
    }
  }

  &-date-picker {
    font-size: 0.81rem;
  }

  &-list {
    margin-top: 0.7rem;

    &-item {
      margin-top: 1rem;
      border-bottom: #ccc 1px solid;

      > div {
        display: flex;
        justify-content: space-between;
        padding: 0.2rem 0.8rem;
        font-size: 0.88rem;
        span {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
